import { Donuz } from "@/donuz-js/Donuz";
import facebookLogin from 'facebook-login-vuejs';


// @ is an alias to /src
export default {
  name: "invite",
  components: {
    facebookLogin
  },
  data() {
    return {
      urlshare: "",
      email: "",
      fbId: 0,
      access_token: '',
      loadingEmail: false
    };
  },
  async created() {
    if(!this.ESTABELECIMENTO.cliente_pode_indicar){
    this.$route.push(this.$route.params.slug + "/");
    }

    this.client = JSON.parse(atob(sessionStorage.getItem(btoa("cliente"))));
    this.urlshare = `http://pts.vc/usr/${this.ESTABELECIMENTO.id}/${
      this.client.id_cliente
      }`;
  },
  methods: {
    submit: async function () {
      this.loadingEmail = true;
      let message = await Donuz.mail.getEmailInvite(this.ESTABELECIMENTO.id);
      message = this.replaceTags(message, this.urlshare);
      message.to = this.email;
      message.mensagem = message.email;
      message.estabelecimento = this.ESTABELECIMENTO.id
      let result = await Donuz.mail.sendMail(message, this.ESTABELECIMENTO.id);
      if (result.status == 200) {
        M.toast({ html: "Mensagem enviada com sucesso!", classes: "green" });
      } else {
        M.toast({ html: "Erro!!!</br>tente novamente", classes: "red center-align" });
      }
      this.loadingEmail = false;
    },
    copy() {
      var copyText = document.getElementById("ptsvc");
      copyText.select();
      copyText.setSelectionRange(0, 99999); /*For mobile devices*/
      document.execCommand("copy");
      M.toast({ html: "Link copiado!", classes: "green" });
    },
    replaceTags: function (dados, $link) {
      let substituicoes = {
        // dados do membro
        "{nome_membro}": this.client.nome,
        "{codigo_membro}": this.client.codigo,
        "{cpf_membro}": this.client.cpf,
        "{login_membro}":
          (!this.empty(this.client.cpf) ? this.client.cpf : "") +
          (!this.empty(this.client.codigo) && !this.empty(this.client.cpf)
            ? " ou "
            : "") +
          (!this.empty(this.client.codigo) ? this.client.codigo : ""),
        "{segundo_nome_membro}": this.client.sobrenome,
        "{foto_membro}": this.client.foto,
        "{endereco_membro}": this.client.endereco,
        "{numero_membro}": this.client.numero,
        "{complemento_membro}": this.client.complemento,
        "{bairro_membro}": this.client.bairro,
        "{cidade_membro}": this.client.cidade,
        "{estado_membro}": this.client.estado,
        "{cep_membro}": this.client.cep,
        "{data_nascimento_membro}": this.client.data_nascimento,
        "{sexo_membro}": this.client.sexo,
        "{link_indique}": $link,

        // pontos
        "{saldo_pontos_membro}": this.client.saldo ? this.client.saldo : 0,
        "{saldo}": this.client.saldo ? this.client.saldo : 0
      };
      dados.email = dados.email.replace('%7B', '{')
      dados.assunto = dados.assunto.replace('%7B', '{')
      dados.email = dados.email.replace('%7D', '}')
      dados.assunto = dados.assunto.replace('%7D', '}')

      Object.entries(substituicoes).map(val => {
        dados.email = dados.email.replace(val[0], val[1]);
        dados.assunto = dados.assunto.replace(val[0], val[1]);
      });
      return dados;
    },
    empty: function (data) {
      return data == null || data == undefined || data.toString().trim() == "";
    },
    checkLoginState: async function (response) {
      this.fbId = response.response.authResponse.userID
      this.access_token = response.response.authResponse.access_token
    },
    checkLogin: async function (response) {
      this.fbId = response.authResponse.userID
      this.access_token = response.authResponse.access_token
    },
    share: async function () {
      let response = await fetch(`https://graph.facebook.com/v3.3/${this.fbId}/feed`, { method: 'POST', body: JSON.stringify({ description: 'teste' }), headers: { 'access_token': this.access_token, 'Content-Type': 'appliction/json' } }).then((data) => data.json())
    }
  }
};
